<template>
  <q-page padding>
    <PageHeader
      title="Listagem de Requisições"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="row teste2 q-mt-md text-brand-5 text-weight-bold q-gutter-sm">
      <div class="col-md col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs">Unidade</div>
        <lista-unidades-select class="input-new-design" v-model="unidade" />
      </div>
      <div class="col-md col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs">Centro de Custo</div>
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="filtros.centro"
        />
      </div>
      <div class="col-md col-xs-4">
        <div class="q-ml-sm text-brand-5 texto-inputs responsivo-teste">
          N: da Requisição
        </div>
        <q-input
          class="input-new-design"
          dense
          outlined
          v-model="filtros.nreq"
        />
      </div>

      <div class="col-md col-xs-3">
        <div class="q-ml-sm text-brand-5 texto-inputs">Solicitante</div>
        <q-input
          class="input-new-design"
          :disable="filtros.listaUser"
          dense
          outlined
          v-model="filtros.solicitante"
        />
      </div>

      <div class="container-datas-mobile">
        <div class="col-md col-xs-3 campo-data-mobile">
          <div class="q-ml-sm text-brand-5 texto-inputs">Data Inicial</div>
          <q-input
            v-model="filtros.dataInicial"
            dense
            outlined
            class="texto-titulo-input input-new-design"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="filtros.dataInicial"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :options="optionsFn"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md col-xs-3 campo-data-mobile">
          <div class="q-ml-sm text-brand-5 texto-inputs">Data Final</div>
          <q-input
            v-model="filtros.dataFinal"
            dense
            outlined
            class="texto-titulo-input input-new-design"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="filtros.dataFinal"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :options="optionsFn"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
      </div>

      <div
        v-if="
          $store.state.autenticacao.cliente.includes('ambev') ||
          $store.state.autenticacao.cliente.includes('staging-ambev')
        "
        class="col-md col-xs-8"
      >
        <div class="q-ml-sm text-brand-5 texto-inputs">Categoria Entre</div>
        <q-select
          :options="categoriaEntreOptions"
          dense
          outlined
          :display-value="filtros.intervalo ? filtros.intervalo.label : 'Todos'"
          v-model="filtros.intervalo"
        />
      </div>
      <div class="bnt-filtrar">
        <p></p>
        <q-btn
          icon="filter_alt"
          no-caps
          style="background-color: #7ab9e0; border-radius: 8px; color: white"
          label="Filtrar"
          @click="atualizar++"
        />
      </div>
      <div
        v-if="
          $store.state.autenticacao.cliente.includes('ambev') ||
          $store.state.autenticacao.cliente.includes('staging-ambev')
        "
        class="col-md-2 col-sm-3 col-xs-5 toggle-container"
      >
        <div class="q-ml-sm toggle-text">Mostrar apenas do usuário logado</div>
        <div>
          <q-toggle
            class="q-ml-sm"
            checked-icon="check"
            color="green"
            unchecked-icon="clear"
            v-model="filtros.listaUser"
            @click="listarUserLogado(filtros.listaUser)"
          />
          <span class="q-ml-sm toggle-text">{{
            filtros.listaUser ? "Habilitado" : "Desabilitado"
          }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="
        !$store.state.autenticacao.cliente.includes('ambev') &&
        !$store.state.autenticacao.cliente.includes('staging-ambev')
      "
      class="col-md-2 col-sm-3 col-xs-5 toggle-container text-brand-5 text-weight-bold"
    >
      <div class="q-ml-sm q-mt-md toggle-text">
        Mostrar apenas do usuário logado
      </div>
      <div>
        <q-toggle
          class="q-ml-sm"
          checked-icon="check"
          color="green"
          unchecked-icon="clear"
          v-model="filtros.listaUser"
          @click="listarUserLogado(filtros.listaUser)"
        />
        <span class="q-ml-sm toggle-text">{{
          filtros.listaUser ? "Habilitado" : "Desabilitado"
        }}</span>
      </div>
    </div>

    <q-tabs
      v-model="tab"
      dense
      class="text-grey q-mt-xl"
      align="justify"
      narrow-indicator
      active-bg-color="brand-11"
      indicator-color="transparent"
      active-color="black"
    >
      <q-tab
        class="q-mr-sm"
        style="background-color: #d9d9d9; border-radius: 4px"
        name="aprovacao"
        label="Aguardando Aprovação"
      />
      <q-tab
        class="q-ml-sm q-mr-sm"
        style="background-color: #d9d9d9; border-radius: 4px"
        name="finalizacao"
        label="Aguardando Finalização"
      />
      <q-tab
        class="q-ml-sm q-mr-sm"
        style="background-color: #d9d9d9; border-radius: 4px"
        name="finalizadas"
        label="Requisições Finalizadas"
      />
      <q-tab
        class="q-ml-sm q-mr-sm"
        style="background-color: #d9d9d9; border-radius: 4px"
        name="deletadas"
        label="Requisições Deletadas"
      />
    </q-tabs>

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel name="aprovacao">
        <tabela-requisicoes
          :title="'Aguardando Aprovação'"
          :requisicao="'aprovacao'"
          :filtros="filtros"
          :atualizar="atualizar"
          :filtrar="filtroSessao.filtrar.value"
        />
      </q-tab-panel>

      <q-tab-panel name="finalizacao">
        <tabela-requisicoes
          :title="'Aguardando Finalização'"
          :requisicao="'finalizacao'"
          :filtros="filtros"
          :atualizar="atualizar"
          :filtrar="filtroSessao.filtrar.value"
        />
      </q-tab-panel>
      <q-tab-panel name="finalizadas">
        <tabela-requisicoes
          :title="'Requisições Finalizadas'"
          :requisicao="'finalizado'"
          :filtros="filtros"
          :atualizar="atualizar"
          :filtrar="filtroSessao.filtrar.value"
        />
      </q-tab-panel>
      <q-tab-panel name="deletadas">
        <tabela-requisicoes
          :title="'Requisições Deletadas Recentemente'"
          :requisicao="'deletados'"
          :filtros="filtros"
          :atualizar="atualizar"
          :filtrar="filtroSessao.filtrar.value"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-page>
</template>

<script>
import TabelaRequisicoes from "../components/TabelaRequisicoes.vue";
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { receberFiltro } from "../composables/receberFiltro";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { watchDebounced } from "@vueuse/core";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: { TabelaRequisicoes, ListaUnidadesSelect, PageHeader },
  name: "RetirarFerramentas",
  setup() {
    const store = useStore();
    const filtroSessao = receberFiltro();

    const tab = ref("aprovacao");
    const unidade = ref();
    const listaRequisicao = ref([]);
    const ativo = ref(true);
    const ativo2 = ref(false);
    const ativo3 = ref(false);
    const ativo4 = ref(false);
    const atualizar = ref(0);
    const inicializacaoCompleta = ref(false);
    const toggleDesabilitado = ref(["wickbold", "staging-wickbold"]);

    const filtros = ref({
      centro: "",
      nreq: "",
      solicitante: "",
      intervalo: "",
      status: "",
      listaUser: false,
      dataFinal: "",
      dataInicial: "",
      userLogadoId: store.state.autenticacao.usuarioLogado.id,
    });
    const requisicoesAguardandoAprovacaoNumero = ref("");
    const aguardandoFinalizacao = ref("");
    const requisicoesFinalizadas = ref("");
    const requisicoesDeletadasNumero = ref("");

    watch(
      () => atualizar.value,
      () => {
        sessionStorage.setItem(
          "/req/requisicao/lista",
          JSON.stringify(filtros.value)
        );
      }
    );

    const listarUserLogado = (value) => {
      if (value) {
        filtros.value.solicitante = filtros.value.userLogadoId;

        return;
      }
      filtros.value.solicitante = "";
    };

    watch(
      () => tab.value,
      () => {
        atualizar.value++;
        sessionStorage.setItem(
          "/req/requisicao/lista",
          JSON.stringify(filtros.value)
        );
      }
    );

    const validacaoTenent = async () => {
      const subdomain = window.location.host.split(".")[1]
        ? window.location.host.split(".")[0]
        : "";
      toggleDesabilitado.value.forEach((e) => {
        if (subdomain.indexOf(e) != -1) {
          filtros.value.listaUser = true;
          return;
        }
      });
      filtros.value.listaUser = false;
      if (filtros.value.listaUser) {
        filtros.value.solicitante = filtros.value.userLogadoId;
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => filtroSessao.filtros.value,
      () => {
        filtros.value = filtroSessao.filtros.value;
      }
    );

    watch(
      () => filtros.value.listaUser,
      () => {
        atualizar.value++;
      }
    );

    watchDebounced(
      [
        () => filtros.value?.centro,
        () => filtros.value?.intervalo,
        () => filtros.value.solicitante,
        () => filtros.value.nreq,
        () => filtros.value.status,
        () => filtros.value.listaUser,
        () => filtros.value.solicitante,
      ],
      () => {
        sessionStorage.setItem(
          "/req/requisicao/lista",
          JSON.stringify(filtros.value)
        );
      },
      { debounce: 400 }
    );

    onMounted(async () => {
      await validacaoTenent();

      const storedFiltros = sessionStorage.getItem("/req/requisicao/lista");
      if (storedFiltros) {
        filtros.value = JSON.parse(storedFiltros);
      }

      inicializacaoCompleta.value = true;

      atualizar.value++;
    });

    let timeout;
    watch(
      () => atualizar.value,
      () => {
        if (!inicializacaoCompleta.value) return;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
          sessionStorage.setItem(
            "/req/requisicao/lista",
            JSON.stringify(filtros.value)
          );
        }, 100);
      }
    );
    return {
      listaRequisicao,
      ativo,
      ativo2,
      ativo3,
      status: [
        {
          label: "Aberto",
          value: "aberto",
        },
        {
          label: "Aprovado",
          value: "aprovado",
        },
        {
          label: "Pendente",
          value: "pendente",
        },
        {
          label: "Rascunho",
          value: "rascunho",
        },
        {
          label: "Rejeitado",
          value: "rejeitado",
        },
      ],
      categoriaEntreOptions: [
        {
          label: "Todos",
          value: "",
        },
        {
          label: "Categoria Proritária",
          value: "A",
        },
        {
          label: "Intervalo de 7 dias",
          value: "B",
        },
        {
          label: "Rascunho",
          value: "rascunho",
        },
        {
          label: "Intervalo de 15 dias",
          value: "C",
        },
      ],
      filtros,
      atualizar,
      ativo4,
      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },

      requisicoesDeletadasNumero,
      requisicoesAguardandoAprovacaoNumero,

      aguardandoFinalizacao,
      requisicoesFinalizadas,
      filtroSessao,

      tab,
      listarUserLogado,
      unidade,
      validacaoTenent,
      optionsFn(date) {
        var hoje = new Date();

        var ontem = new Date(hoje.getTime());
        ontem.setDate(hoje.getDate());

        var dd = ontem.getDate();
        var mm = ontem.getMonth() + 1;
        var yyyy = ontem.getFullYear();

        if (dd < 10) {
          dd = "0" + dd;
        }

        if (mm < 10) {
          mm = "0" + mm;
        }

        var data_ok = yyyy + "/" + mm + "/" + dd;

        return date <= data_ok;
      },
    };
  },
};
</script>

<style scoped>
.q-tab-panel {
  padding: 0px;
}
.ativo {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}

.ativo2 {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}

.ativo3 {
  color: white !important;
  background-color: red !important;
  border-radius: 3px;
}

.ativo4 {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}
.bnt-filtrar {
  margin-top: 16px;
}

@media (max-width: 600px) {
  .responsivo {
    margin-top: 20px;
  }
  .btns-listas {
    margin: 0 8px 0 0;
    padding: 10px 10px 10px 0px;
    font-size: 11px !important;
    width: 170px;
  }
  .teste2 {
    margin: 10px 0 0 0;
    padding: 0px;
  }
  .bnt-filtrar {
    margin-top: 13px;
  }
  .titulo-pagina {
    margin-top: 10px;
    font-size: 14px;
  }
  .inputs-centro-de-custo {
    width: 100px;
    margin-left: 0;
    margin-right: 3px;
  }
  .inputs-numero-requisicao {
    width: 120px;
    margin-left: 0;
    margin-right: 3px;
  }
  .inputs-status-requisicao {
    width: 120px;
    margin-left: 0;
    margin-right: 3px;
  }
  .inputs-solicitante {
    width: 120px;
    margin-left: 0;
    margin-right: 3px;
  }
  .inputs-categoria {
    width: 120px;
    margin-left: 0;
    margin-right: 1px;
  }
  .texto-btn-listas {
    font-size: 9px;
  }
  .texto-inputs {
    font-size: 11px;
    margin-left: 0px;
  }
  .btns-listas-container {
    margin: 30px 0 0 0;
    padding: 0;
  }
  .toggle-text {
    font-size: 12px;
  }
  .toggle-container {
    margin-top: 20px 0px 0px 0px;
  }
}

.container-datas-mobile {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.container-datas-mobile .campo-data-mobile {
  flex: 1;
  min-width: 0;
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .col-md,
  .col-xs-4,
  .col-xs-3 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .container-datas-mobile {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
    gap: 8px !important;
    margin-bottom: 16px !important;
  }

  .container-datas-mobile .campo-data-mobile {
    width: 48% !important;
    flex: 1 !important;
    max-width: 48% !important;
    margin-bottom: 0 !important;
  }

  .row.teste2.q-mt-md.text-brand-5.text-weight-bold.q-gutter-sm {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .texto-inputs {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .q-ml-sm {
    margin-left: 0 !important;
  }

  .bnt-filtrar {
    width: 100% !important;
    margin-top: 16px !important;
    display: flex !important;
    justify-content: center !important;
  }

  .bnt-filtrar .q-btn {
    width: 100% !important;
    max-width: 300px !important;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .q-page {
    padding: 8px !important;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
